import React from 'react';

function AGBPage() {
  return (
    <div className="container mx-auto px-4 lg:px-12 py-8 max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 uppercase">
        Allgemeine Geschäftsbedingungen (AGB)
      </h1>

      <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8 rounded">
        <p className="text-amber-800 font-medium">
          Diese AGB gelten ausschließlich für Geschäfte mit Unternehmern (B2B) im Sinne von § 14 BGB.
        </p>
      </div>

      <div className="prose prose-gray max-w-none space-y-8">
        {/* § 1 Geltungsbereich */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 1 Geltungsbereich</h2>
          <p className="text-gray-700">
            (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle 
            Geschäftsbeziehungen zwischen ED STEEL, Inhaber Erkan Deniz (nachfolgend „Verkäufer") 
            und dem Kunden (nachfolgend „Käufer"), soweit der Käufer Unternehmer im Sinne von 
            § 14 BGB ist.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Unternehmer im Sinne dieser AGB ist eine natürliche oder juristische Person oder 
            eine rechtsfähige Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in 
            Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit handelt.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des 
            Käufers werden nur dann und insoweit Vertragsbestandteil, als der Verkäufer ihrer 
            Geltung ausdrücklich schriftlich zugestimmt hat.
          </p>
          <p className="text-gray-700 mt-2">
            (4) Diese AGB gelten auch für alle zukünftigen Geschäfte mit dem Käufer.
          </p>
        </section>

        {/* § 2 Vertragsschluss */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 2 Vertragsschluss</h2>
          <p className="text-gray-700">
            (1) Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes 
            Angebot, sondern eine unverbindliche Aufforderung zur Bestellung (invitatio ad offerendum) dar.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Durch Anklicken des Buttons „Kostenpflichtig bestellen" bzw. „Jetzt kaufen" gibt 
            der Käufer ein verbindliches Kaufangebot ab.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Der Kaufvertrag kommt zustande, wenn der Verkäufer das Angebot des Käufers durch 
            eine Auftragsbestätigung per E-Mail oder durch Lieferung der Ware annimmt.
          </p>
          <p className="text-gray-700 mt-2">
            (4) Der Vertragstext wird vom Verkäufer gespeichert. Der Käufer kann den Vertragstext 
            vor Absenden der Bestellung ausdrucken.
          </p>
        </section>

        {/* § 3 Preise und Zahlungsbedingungen */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 3 Preise und Zahlungsbedingungen</h2>
          <p className="text-gray-700">
            (1) Alle Preise verstehen sich in Euro (€) und sind, sofern nicht anders angegeben, 
            Nettopreise zuzüglich der jeweils gültigen gesetzlichen Umsatzsteuer.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Zusätzlich zu den Produktpreisen fallen Versandkosten an. Die Höhe der Versandkosten 
            wird im Bestellprozess vor Abschluss der Bestellung ausgewiesen:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>Standardversand innerhalb Deutschlands: 6,90 €</li>
            <li>Kostenloser Versand ab einem Bestellwert von 200,00 €</li>
          </ul>
          <p className="text-gray-700 mt-2">
            (3) Folgende Zahlungsarten stehen zur Verfügung:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>Kreditkarte (Visa, Mastercard)</li>
            <li>PayPal</li>
            <li>Nachnahme (Barzahlung bei Lieferung)</li>
          </ul>
          <p className="text-gray-700 mt-2">
            (4) Bei Zahlung per Nachnahme ist der Kaufpreis bei Übergabe der Ware an den 
            Transportdienstleister in bar zu entrichten.
          </p>
          <p className="text-gray-700 mt-2">
            (5) Kommt der Käufer in Zahlungsverzug, ist der Verkäufer berechtigt, Verzugszinsen 
            in Höhe von 9 Prozentpunkten über dem jeweiligen Basiszinssatz zu verlangen.
          </p>
        </section>

        {/* § 4 Lieferung und Gefahrübergang */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 4 Lieferung und Gefahrübergang</h2>
          <p className="text-gray-700">
            (1) Die Lieferung erfolgt an die vom Käufer angegebene Lieferadresse innerhalb 
            Deutschlands.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Die Lieferzeit beträgt, sofern nicht anders angegeben, 2-5 Werktage nach 
            Zahlungseingang bzw. bei Nachnahme nach Auftragsbestätigung.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Ist der Käufer Unternehmer, geht die Gefahr des zufälligen Untergangs und der 
            zufälligen Verschlechterung der Ware auf den Käufer über, sobald der Verkäufer die 
            Sache dem Spediteur, dem Frachtführer oder der sonst zur Ausführung der Versendung 
            bestimmten Person oder Anstalt ausgeliefert hat.
          </p>
          <p className="text-gray-700 mt-2">
            (4) Teillieferungen sind zulässig, soweit sie dem Käufer zumutbar sind.
          </p>
        </section>

        {/* § 5 Eigentumsvorbehalt */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 5 Eigentumsvorbehalt</h2>
          <p className="text-gray-700">
            (1) Die gelieferte Ware bleibt bis zur vollständigen Bezahlung aller Forderungen aus 
            dem Kaufvertrag Eigentum des Verkäufers.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Der Käufer ist verpflichtet, die Ware pfleglich zu behandeln. Er ist verpflichtet, 
            den Verkäufer unverzüglich schriftlich zu informieren, wenn Dritte auf die Ware 
            zugreifen, etwa im Falle einer Pfändung.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Bei vertragswidrigem Verhalten des Käufers, insbesondere bei Zahlungsverzug, ist 
            der Verkäufer berechtigt, vom Vertrag zurückzutreten und die Ware herauszuverlangen.
          </p>
        </section>

        {/* § 6 Mängelansprüche / Gewährleistung */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 6 Mängelansprüche / Gewährleistung</h2>
          <p className="text-gray-700">
            (1) Es gelten die gesetzlichen Gewährleistungsrechte mit folgenden Maßgaben:
          </p>
          <p className="text-gray-700 mt-2">
            (2) Der Käufer hat die Ware unverzüglich nach Erhalt auf Mängel zu untersuchen und 
            erkennbare Mängel innerhalb einer Frist von einer Woche nach Erhalt schriftlich 
            gegenüber dem Verkäufer anzuzeigen. Verdeckte Mängel sind unverzüglich nach 
            Entdeckung anzuzeigen.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Die Gewährleistungsfrist für Unternehmer beträgt ein Jahr ab Lieferung der Ware.
          </p>
          <p className="text-gray-700 mt-2">
            (4) Bei Vorliegen eines Mangels steht dem Verkäufer zunächst das Recht zur 
            Nacherfüllung (Nachbesserung oder Ersatzlieferung) zu.
          </p>
        </section>

        {/* § 7 Haftung */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 7 Haftungsbeschränkung</h2>
          <p className="text-gray-700">
            (1) Der Verkäufer haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für 
            Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Bei leichter Fahrlässigkeit haftet der Verkäufer nur bei Verletzung wesentlicher 
            Vertragspflichten (Kardinalpflichten). Die Haftung ist in diesem Fall auf den 
            vorhersehbaren, vertragstypischen Schaden begrenzt.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Die vorstehenden Haftungsbeschränkungen gelten auch zugunsten der Erfüllungsgehilfen 
            des Verkäufers.
          </p>
          <p className="text-gray-700 mt-2">
            (4) Eine Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
          </p>
        </section>

        {/* § 8 Widerrufsrecht */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 8 Widerrufsrecht</h2>
          <div className="bg-gray-100 border-l-4 border-gray-500 p-4 rounded">
            <p className="text-gray-700 font-medium">
              Ein gesetzliches Widerrufsrecht besteht für Unternehmer (B2B) nicht.
            </p>
            <p className="text-gray-700 mt-2">
              Kulanzregelungen können im Einzelfall individuell vereinbart werden.
            </p>
          </div>
        </section>

        {/* § 9 Datenschutz */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 9 Datenschutz</h2>
          <p className="text-gray-700">
            Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer 
            Datenschutzerklärung.
          </p>
        </section>

        {/* § 10 Gerichtsstand und anwendbares Recht */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 10 Gerichtsstand und anwendbares Recht</h2>
          <p className="text-gray-700">
            (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des 
            UN-Kaufrechts (CISG).
          </p>
          <p className="text-gray-700 mt-2">
            (2) Ist der Käufer Kaufmann, juristische Person des öffentlichen Rechts oder 
            öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle 
            Streitigkeiten aus diesem Vertrag der Geschäftssitz des Verkäufers.
          </p>
        </section>

        {/* § 11 Schlussbestimmungen */}
        <section>
          <h2 className="text-xl font-bold mb-4">§ 11 Schlussbestimmungen</h2>
          <p className="text-gray-700">
            (1) Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein oder werden, so 
            wird hierdurch die Gültigkeit der übrigen Bestimmungen nicht berührt.
          </p>
          <p className="text-gray-700 mt-2">
            (2) Änderungen und Ergänzungen dieses Vertrages bedürfen der Schriftform. Dies gilt 
            auch für die Aufhebung dieses Schriftformerfordernisses.
          </p>
          <p className="text-gray-700 mt-2">
            (3) Die Vertragssprache ist Deutsch.
          </p>
        </section>

        {/* Stand */}
        <section className="pt-4 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            Stand: Februar 2026
          </p>
        </section>
      </div>
    </div>
  );
}

export default AGBPage;
